import script from "./PeriodItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PeriodItem.vue?vue&type=script&setup=true&lang=js"

import "./PeriodItem.vue?vue&type=style&index=0&id=35a765d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a765d8"]])

export default __exports__